
import { px2 } from '@/lib/utils';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'DaisySpinner',
})
export default class Daisy extends Vue {
    /** 尺寸 */
    @Prop({ type: Number, default: 48 }) public size!: number;
    @Prop({ type: Number, default: 12 }) public indicatorSize!: number;
    @Prop({ type: Number, default: 10 }) public indicatorOffset!: number;

    public get width() {
        return px2.rem6(this.size) + 'rem';
    }
    public get indicatorWidth() {
        return px2.rem6(this.indicatorSize) + 'rem';
    }
    public get indicatorX() {
        return px2.rem6(this.indicatorOffset) + 'rem';
    }
}
